import * as React from "react";
import $ from "./LoadingDots.module.scss";

const LoadingDots: React.FC = () => (
    <>
        <span className={$.dot}>.</span>
        <span className={$.dot}>.</span>
        <span className={$.dot}>.</span>
    </>
);
export default LoadingDots;
